const breakpointsRaw = Object.freeze({
  minimalSupportedWidth: 320,
  sm: 500,
  lg: 1084,
  xl: 1284
});

export default breakpointsRaw;
